module.exports = __webpack_public_path__ + "img/examples.fb010013.png";